export default __webpack_public_path__ + "static/media/1.d407edf2.jpg";